import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'

export const schema = yup.object({
  specie: yup.string().required(),
  notes: yup.string().required().max(256),
  observed_at: yup.date().required(),
  photos: mediaSchema,
  related_observation_log_id: yup.string().required(),
})
